import { Api } from "./../api/axios-config"


export interface IDadosRetorno {
    dado: any;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

const recuperarSenha = async (email: string): Promise<IDadosRetorno> => {

    const { data } = await Api.put<IDadosRetorno>("/Usuario/recuperarsenha", "", {
        headers: {
            "email": email
        }
    });
    return data;

}

const validarCodigo = async (codigo: string): Promise<IDadosRetorno> => {

    const { data } = await Api.get<IDadosRetorno>("/Usuario/recuperarsenha/validarcodigo", {
        params: {
            Codigo: codigo ? codigo : null
        }
    });
    return data;
}


const alterarSenha = async (novaSenha: string, confirmarNovaSenha: string, token: string): Promise<IDadosRetorno> => {
    const { data } = await Api.put<IDadosRetorno>("/Usuario/alterarsenha", { novaSenha: novaSenha, confirmarNovaSenha: confirmarNovaSenha }, {
        headers: {
            "token": token
        }
    });

    return data;

}

export const EsqueciSenhaService = {
    recuperarSenha,
    validarCodigo,
    alterarSenha
}